const cityToggleConfig = cityId => ({
  originalDocumentUploadCities: ['berlin', 'paris'].includes(cityId),
  isNoDepositSupported: ['milan', 'rome'].includes(cityId),
  isSuperListerSupported: !['paris'].includes(cityId),
  showSelectInfoCard: false,
  isSelectFilterActive: false,
  isSearchAlgorithmExperimentEnabled: !['madrid', 'london'].includes(cityId)
});

export default cityToggleConfig;
